import React, { Component } from 'react';
import { Link } from 'react-router';
import AdminTitle from '../../components/AdminTitle';
import LiveSearch from '../../components/LiveSearch';
import Api, { Utils } from '../../Api';
import FontAwesome from 'react-fontawesome';

export default class AdminHome extends Component {
  constructor() {
    super();

    Utils.bindThis(this, [
      'executeSearch',
      'onActiveOnlyChange',
      'onSearchChange',
      'refresh'
    ]);

    this.state = {
      brands: [],
      search: '',
      waitingSearch: false,
      activeOnly: false,
      searchResults: []
    };
  }

  refresh() {
    Api.getBrands()
    .then(
      (response) => {
        this.setState({
          brands: response
        });
      }
    );
  }

  componentDidMount() {
    this.refresh();
  }

  onActiveOnlyChange() {
    this.setState({ activeOnly: this.refs['active_only'].checked });
  }

  onSearchChange(value) {
    let payload = {search: value};
    if (value === '') payload.searchResults = [];
    this.setState(payload);
  }

  executeSearch() {
    if (this.state.search.length === 0) return;

    Api.getBrands(this.state.search, this.state.activeOnly)
    .then(
      (response) => {
        this.setState({
          waitingSearch: false,
          searchResults: response
        });
      }
    );

    this.setState({ waitingSearch: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search.trim() !== prevState.search.trim() || this.state.activeOnly !== prevState.activeOnly) {
      if (this.state.search.trim().length > 0) this.executeSearch();
    }

    if (this.state.activeOnly !== prevState.activeOnly) {
      this.refresh();
    }
  }

  contents() {
    let brands = [];

    if (this.state.search.length === 0) {
      brands = this.state.brands;
    } else {
      brands = this.state.searchResults;
    }

    return brands
      .sort((a, b) => {
        return (a.name.localeCompare(b.name));
      })
      .map((brand) => {
        let inactiveStatus = null;
        let link = `/admin/brand/${brand.token}/edit`;

        let imageUrl;
        if (brand.images && brand.images.length > 0) {
          imageUrl = brand.images[0].url;
        }

        let brandImage = null;
        if (brand.images && brand.images.length > 0) {
          brandImage = <img role="presentation" src={brand.images[0].url}/>
        }

        if (brand.active === false) inactiveStatus = <FontAwesome name="exclamation-circle"/>;
        return (
          <span key={brand.token} className={`brand-list-item brand-${brand.token}`}>
          <div className={`brand-image${!!brandImage ? '' : ' hidden'}`}>{brandImage}</div>
          <div className="brand-line-1">
            <span className="brand-status-icon">{inactiveStatus}</span>
            <span
              className="commission">{brand.commission_bps ? parseFloat(brand.commission_bps / 100).toFixed(2) + '%' : ''}</span>
            <Link to={link} className="brand-name">
              {brand.name}
            </Link>
            <span className={`brand-image${!!imageUrl ? '' : ' hidden'}`}><img role="presentation"
                                                                               src={imageUrl}
                                                                               height="15px"/></span>
            <span className="brand-url"><a href={brand.url} target="_blank">{brand.url}</a></span>
          </div>
          <div className="brand-line-2">
            <p>{brand.description}</p>
          </div>
        </span>
        );
      });
  }

  render() {
    return (
      <div>
        <AdminTitle title="Brand List">
          <Link to="/admin/create" className="button button--small">New Brand</Link>
        </AdminTitle>
        <LiveSearch onChange={this.onSearchChange} waitingSearch={this.state.waitingSearch} placeholder="Search Brands">
          <span className="active-only-block">
            <input type="checkbox" id="active_only" ref="active_only" onChange={this.onActiveOnlyChange} />
            <label htmlFor="active_only">Active Only</label>
          </span>
        </LiveSearch>
        <div className="brand-list">
          {this.contents()}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/Brand.js
 **/